/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : cart-details-reducer.ts
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H352615
*
* @Date         : AUG 2, 2019
*
* @Version      : Version 1.0
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : Integrated get cart details servcies , updated respective reducer(ASDS-909)
 *
 * By            : H352615
 * On            : Aug 16, 2019
 * Description   : Integrated Cart view response structure with ASDS-909
 *
 * By            : H224423
 * On            : Sep 25, 2019
 * Description   : ASDS-411 Edit cart Item Aspire changes
 *
 * By            : H224423
 * On            : Sep 30, 2019
 * Description   : ASDS-412 Edit cart details changes
 *
 * By            : E807238
 * On            : Nov 1, 2019
 * Description   : ASDS-1693: Unable to delete product in cart
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1953
 *
 * By            : Deepthi Bachu(E844276)
 * On            : Mar 13, 2020
 * Description   : ASDS-2414 - APU MSA - acknowledge after deleting product from cart for address change
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3260 UI Enhancements for Phase - II
 *
 * By            : H422336
 * On            : Oct 13, 2020
 * Description   : ASDS - 3262, ASDS-3263 UI Enhancements for Phase - II
 *
 * By            : H422336
 * On            : Oct, 16 2020
 * Description   : ASDS-3268 UI Enhancements for Phase-II
 *
 * By            : H422336
 * On            : Oct, 22 2020
 * Description   : ASDS-3535 UI Enhancements for Phase-II
 *
 * By            : H422337
 * On            : Oct 27, 2020
 * Description   : ASDS-3555 - UI Enhancements for Phase - II -migrate to Forge API
 *
 * By            : H422337
 * On            : Nov 01, 2020
 * Description   : ASDS-3265 Enhancements of phase-2 - Purchase Order Quantity validation
 *
 * By            : H422337
 * On            : Nov 04, 2020
 * Description   : ASDS-3572,ASDS-3573 Enhancements of phase-2 - Edit Aspire product changes
 *
******************************************************************************/

import Reducer from './reducer';
import { AsdsReduxAction } from '../../../../types';
import { createReducer } from '../utils/redux-util';
import ActionConstants from '../action-constants';

class CartDetailsReducer extends Reducer {

    static abstractCartDetails(state, action: AsdsReduxAction) {
        return {
            ...state,
            abstractView: action.payload,
        };
    }

    // static getAbstractCartDetails(state, action: AsdsReduxAction) {
    //     return {
    //         ...state,
    //         abstractView:action.payload,
    //     };
    // }

    static setSelectedCartList(state, action: AsdsReduxAction) {
        return {
            ...state,
            selectedCartList: {
                cartList: action.payload.data,
                totalAmount: action.payload.amount,
                isFetching: action.payload.isFetching,
                isSuccess: action.payload.isSuccess
            }
        }
    }

    static getSelectedCartList(state, _action: AsdsReduxAction) {
        return {
            ...state,
            selectedCartList: {cartList: [], totalAmount: 0, isFetching: true, isSuccess: false,}
        };
    }

    /**
     *
     * @param state Method to show cart line item edit model
     * @param action
     */
    static showEditModel(state, action: AsdsReduxAction){
        return {
            ...state,
            openEditModel : true,
            editProductDetails: {
                'productSeq': action.payload.product.prodSeq,
                'productId': action.payload.product.prodId,
                'productName': action.payload.product.prodName,
            }
        };
    }

    /**
     *
     * @param state Method to show cart line item edit model
     * @param action
     */
    static cartAPUEditModel(state, action: AsdsReduxAction){
        return {
            ...state,
            openAPUConfigModel : true,
            editAPUProductDetails: {
                'productSeq': action.payload.product.customerType.prodSeq,
                'productId': action.payload.product.prodId,
                'productName': action.payload.product.prodName,
            }
        };
    }

    /**
     * Method to hide cart line item edit model
     * @param state
     */
    static hideEditModel (state) {
        return {
            ...state,
            openEditModel : false,
        };
    }

    /**
     * Method to hide cart line item edit model
     * @param state
     */
    static hideAPUEditModel (state) {
        return {
            ...state,
            openAPUConfigModel : false,
        };
    }

    static showErrorOnDeleteProd(state, action: AsdsReduxAction){
        return{
            ...state,
            errorOnDelete : true,
            lastDeleteProdName: action.payload.lastDeleteProdName,
        };
    }

    static showProductDeleteMsg(state, action: AsdsReduxAction) {
        return {
            ...state,
            showDeleteMsgFlag : action.payload.showDeleteMsgFlag
        };
    }

    static checkProductDeleted(state, action: AsdsReduxAction) {
        return {
            ...state,
            isProductDeleted : action.payload.isProductDeleted
        };
    }

    static toggleDeletePopUp(state, action: AsdsReduxAction) {
        return {
            ...state,
            showDeletePopUp : action.payload.showDeletePopUp,
            product: action.payload.product
        };
    }

    static checkForPriceChange(state, action: AsdsReduxAction) {
        return {
            ...state,
            hasPriceChanged: action.payload.hasPriceChanged
        };
    }

    static hideErrorOnDeleteProd(state, action: AsdsReduxAction){
        return{
            ...state,
            errorOnDelete : false,
            lastDeleteProdName: action.payload.lastDeleteProdName,
        };
    }
    static setErrorOnEditProd(state, action: AsdsReduxAction){
        return{
            ...state,
            errorOnEdit : action.payload.errorOnEdit,
            lastEditProdName: action.payload.lastEditProdName,
        };
    }
    static updatedeleteAllProductsSuccessFlag(state, action: AsdsReduxAction) {

        return{
            ...state,
            deleteAllProductsSuccessFlag: action.payload.flag
        };
    }
    static updateDeleteNonMSAPOSuccessFlag(state, action: AsdsReduxAction) {
        return{
            ...state,
            deleteNonMSAPOSuccessFlag: action.payload.flag
        };
    }



    /**
     *
     * @param state Method to show cart line item edit model
     * @param action
     */
    static cartWirelessEditModel(state, action: AsdsReduxAction){
        return {
            ...state,
            openWirelessConfigModel : true,
            editWirelessProductDetails: {
                'productSeq': action.payload.product.wireless[0].prodSeq,
                'productId': action.payload.product.prodId,
                'productName': action.payload.product.prodName,
                'productIcon': action.payload.product.attributeName,
                'price' : action.payload.product.wireless[0].unitPrice, // since price is same for all the tails, taking the value from first object
            }
        };
    }

    /**
     * Method to hide cart line item edit model
     * @param state
     */
    static hideWirelessEditModel (state) {
        return {
            ...state,
            openWirelessConfigModel : false,
        };
    }

    static editProductToCartLoader(state){
        return{
            ...state,
            abstractView:{
                isFetching: true,
                isSuccess: state.abstractView.isSuccess,
                cartDetails: state.abstractView.cartDetails
            }
        }
    }

    static setToasterNotification(state, action: AsdsReduxAction) {
        return{
            ...state,
            notify: action.payload.notify
        }
    }

    static openCartIcon(state, action: AsdsReduxAction) {
        return{
            ...state,
            openCartIcon: action.payload.openCartIcon
        }
    }
    static checkForPOQuantityInCart(state, action: AsdsReduxAction) {
        return{
            ...state,
            isCheckedQuantityInCart: action.payload.isCheckedQuantityInCart
        }
    }
}

const cartDetailsHandlers = {
    [ActionConstants.SET_ABSTRACT_CART_VIEW]: CartDetailsReducer.abstractCartDetails,
    [ActionConstants.GET_ABSTRACT_CART_VIEW]: CartDetailsReducer.abstractCartDetails,
    [ActionConstants.GET_SELECTED_CART_LIST]: CartDetailsReducer.getSelectedCartList,
    [ActionConstants.SET_SELECTED_CART_LIST]: CartDetailsReducer.setSelectedCartList,
    [ActionConstants.SHOW_EDIT_MODEL]: CartDetailsReducer.showEditModel,
    [ActionConstants.RESET_CONFIGURE_PRODUCT_MYCART]: CartDetailsReducer.hideEditModel,
    [ActionConstants.SHOW_EDIT_MODEL_APU]: CartDetailsReducer.cartAPUEditModel,
    [ActionConstants.HIDE_EDIT_MODEL_APU]: CartDetailsReducer.hideAPUEditModel,
    [ActionConstants.SHOW_ERROR_ON_DELETE_PROD]: CartDetailsReducer.showErrorOnDeleteProd,
    [ActionConstants.HIDE_ERROR_ON_DELETE_PROD]: CartDetailsReducer.hideErrorOnDeleteProd,
    [ActionConstants.SET_ERROR_ON_EDIT_PROD]: CartDetailsReducer.setErrorOnEditProd,
    [ActionConstants.SHOW_EDIT_MODEL_WIRELESS]: CartDetailsReducer.cartWirelessEditModel,
    [ActionConstants.HIDE_EDIT_MODEL_WIRELESS]: CartDetailsReducer.hideWirelessEditModel,
    [ActionConstants.MSA_SUCCESS_FLAG]:CartDetailsReducer.updatedeleteAllProductsSuccessFlag,
    [ActionConstants.EDIT_PRODUCT_TO_CART_LOADER]:CartDetailsReducer.editProductToCartLoader,
    [ActionConstants.SHOW_DELETE_MSG]: CartDetailsReducer.showProductDeleteMsg,
    [ActionConstants.CHECK_DELETE_PRODUCT_SUCCESS]: CartDetailsReducer.checkProductDeleted,
    [ActionConstants.TOGGLE_DELETE_POPUP]: CartDetailsReducer.toggleDeletePopUp,
    [ActionConstants.CHECK_FOR_PRICE_CHANGE]: CartDetailsReducer.checkForPriceChange,
    [ActionConstants.SET_TOASTER]: CartDetailsReducer.setToasterNotification,
    [ActionConstants.OPEN_CART_ICON]: CartDetailsReducer.openCartIcon,
    [ActionConstants.NON_MSA_PO_SUCCESS_FLAG]: CartDetailsReducer.updateDeleteNonMSAPOSuccessFlag,
    [ActionConstants.CHECK_FOR_PO_QUANTITY_IN_CART] : CartDetailsReducer.checkForPOQuantityInCart
};

const initialState = {
    abstractView: {
        isFetching: true,
        isSuccess: false,
        cartDetails: {
            cartList : []
        },
    },
    selectedCartList: {
        cartList: [],
        totalAmount: 0,
        isFetching: true,
        isSuccess: false,
    },
    openEditModel: false, // variable to open/hide edit model
    openAPUConfigModel:false,
    openWirelessConfigModel:false,
    errorOnDelete: false,
    showDeletePopUp: false,
    product: {},
    showDeleteMsgFlag: false,
    isProductDeleted: false,
    lastDeleteProdName:'',
    errorOnEdit: false,
    lastEditProdName: '',
    deleteAllProductsSuccessFlag: false,
    hasPriceChanged: false,
    notify: 'bottom-right',
    openCartIcon: false,
    deleteNonMSAPOSuccessFlag: false,
    isCheckedQuantityInCart: true,
};

export const cartDetails = createReducer(initialState, cartDetailsHandlers);